var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"mci-btn",class:[
    _vm.color,
    _vm.type,
    _vm.size,
    {
      transparent: _vm.transparent,
      outline: _vm.outline,
      rounded: _vm.rounded,
      icon: _vm.icon
    }
  ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick,"blur":_vm.onBlur}},[(_vm.prepareIcon)?_c('span',{staticClass:"prepare",class:_vm.prepareIcon}):_vm._e(),_vm._t("default"),(_vm.appendIcon)?_c('span',{staticClass:"append",class:_vm.appendIcon}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }